import { FmsApi } from "../fmsapi"
import type { ApiResponse, Email } from "../models/responsedto"
import BaseController from "./base"

export class WebserviceController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "webservice")
  }

  public async send_html_mail(email: Email): Promise<ApiResponse> {
    return await this.callApi("send_html_mail", email)
  }
}
